export default __webpack_public_path__ + "svg/Icon_80_list.svg";